import * as React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
  Typography,
  Box,
  Container,
  TextField,
  CssBaseline,
  Avatar,
  Select,
  MenuItem,
  IconButton,
  CircularProgress,
  Paper,
  FormControl,
  Tabs,
  Tab
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { connect } from "react-redux";
import { loginIMSAdmin, signUp } from "../../app/store/actions/authActions";
import {
  Navigate,
  NavLink,
  Route,
  Routes,
  useNavigate,
  useParams
} from "react-router-dom";
import {
  centered_flex_box,
  MainInput,
  MainInputLabel,
  MainPassword,
  main_button,
  StyledInput,
  MainPhone,
  sec_button
} from "../../app/components/Styles";
import { isMobile } from "react-device-detect";
import { Image, Space, Table, Button, notification } from "antd";
import {
  antTableWrapperSx,
  tableShowTotal,
  idTableColumn,
} from "../../app/components/AntTableStyles";
import Logo from "../../app/components/logo.png";
import PropTypes from "prop-types";
import MuiPhoneNumber from "material-ui-phone-number";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import ImageComponent from "../../app/components/ImageComponent";
import { getNotifications } from "../../app/store/actions/imsAdminActions";
import { useEffect } from "react";
import { AddCircleOutline } from "@mui/icons-material";

export const NotificationsList = ({
  getNotifications,
  user,
  notifications,
  isLoading
}) => {
  const navigate = useNavigate();
  const [error, setError] = React.useState(null);
  const [terms, setTerms] = React.useState(false);
  const currentLocale = Cookies.get("i18next") || "en";
  const { t, i18n } = useTranslation();

  useEffect(() => {
    getNotifications({ page: 1, limit: 10000 })
  }, [])

  const columns = [
    idTableColumn(),
    {
      title: 'Content',
      dataIndex: 'content',
      render: (text) => (
        <div style={{ maxWidth: '300px', wordWrap: 'break-word' }}>
          {text}
        </div>
      ),
    },
    {
      title: 'Viewed',
      dataIndex: 'viewed',
      render: (viewed) => (
        <span style={{ color: 'green', fontWeight: 'bold' }}>
          {viewed || 0}
        </span>
      ),
    },
    {
      title: 'Unviewed',
      dataIndex: 'unviewed',
      render: (unviewed) => (
        <span style={{ color: 'red', fontWeight: 'bold' }}>
          {unviewed || 0}
        </span>
      ),
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      render: (date) => new Date(date).toLocaleDateString(),
    },
  ];

  const data = notifications?.docs?.map((row) => {
    return {
      _id: row._id,
      content: row.content,
      viewed: row.viewed,
      unviewed: row.unviewed,
      createdAt: row.createdAt
    }
  })

  return (
    <div>
      <Box sx={{ width: "100%", px: 5 }}>
        <Box sx={{ ...centered_flex_box, mb: 1 }}>
          <Typography variant='h4' sx={{ color: "var(--secColor)" }}>Notifications</Typography>
          <IconButton onClick={() => navigate("/ims/admin/notifications/create")} sx={{ color: "var(--secColor)", mx: 2 }}><AddCircleOutline /></IconButton>
        </Box>
        <Box sx={antTableWrapperSx(isMobile, 800)}>
          <Table
            columns={columns}
            dataSource={data}
            loading={isLoading}
            showSorterTooltip={{
              target: 'sorter-icon',
            }}
            pagination={{
              pageSize: 10,
              showSizeChanger: true,
              showQuickJumper: false,
              showTotal: tableShowTotal("notifications"),
              total: data?.length || 0,
            }}
            scroll={{ x: isMobile ? 300 : 800 }}
          />
        </Box>
      </Box>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  isLoading: state?.records?.isLoading || state?.wait?.isLoading,
  token: state?.auth?.token,
  notifications: state?.records?.notifications
});

const mapDispatchToProps = { getNotifications };

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsList);
